import styled from "styled-components";

export const QrPageWrapper = styled.div<{ inset: number | null }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100vh - 76px);
  background-color: #fff;
  padding-top: ${(props) => props.inset || 0}px;
  z-index: 119;
  overflow-y: auto;
`;

export const QrPageHeader = styled.div`
  position: sticky;
  top: 0;
  background-color: white;
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px 0 20px;
`;

export const QrPageHeaderLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  color: var(--Black-400, #444);
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const QrPageHeaderRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;

export const QrSeedWrapper = styled.div`
  margin: 20px 16px 12px;
  width: calc(100% - 32px);
  height: 89px;
  display: flex;
  flex-direction: column;
  padding: 20px 0 20px 16px;
  justify-content: center;
  gap: 5px;
  border-radius: 9px;
  background-image: url(/image-web/home/wallet-back.svg);
  background-size: cover;
  backface-visibility: hidden;
  > .title {
    color: rgba(255, 255, 255, 0.75);
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.091px;
  }

  > .balance-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
    > .balance {
      color: #fff;
      font-family: esamanru;
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }

    > .bar {
      color: rgba(255, 255, 255, 0.6);
      font-family: Pretendard;
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: -0.457px;
    }

    > .point {
      color: rgba(255, 255, 255, 0.6);
      font-family: Pretendard;
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: -0.457px;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 3px;

      > span {
        color: rgba(255, 255, 255, 0.8);
        font-family: Pretendard;
        font-size: 13px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: -0.091px;
      }
    }
  }
`;

export const QrWrapper = styled.div`
  margin: 0 16px;
  width: calc(100% - 32px);
  height: calc(100vw - 32px);
  border-radius: 7px;
  border: 2px solid #8d6de8;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const QrExpiredWrapper = styled.div`
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  width: 47px;
  height: 17px;
  border-radius: 7px;
  border: 1px solid #8d6de8;
  background: #4e3da3;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-align: center;
  font-family: esamanru;
  font-size: 9px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.731px;
`;

export const QrUserNameWrapper = styled.div`
  margin: 0 16px;
  width: calc(100% - 32px);
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-top: 19px;

  > .title {
    color: #808080;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.091px;
  }

  > .value {
    color: #121212;
    font-family: Pretendard;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const QrUserInfoWrapper = styled.div`
  margin: 12px 16px 30px;
  width: calc(100% - 32px);
  display: flex;
  flex-direction: row;
  gap: 68px;
`;

export const QrUserInfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;

  > .title {
    color: #808080;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.091px;
  }

  > .value {
    color: #121212;
    font-family: Pretendard;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;
